GLOBALS = (function () {
  const NUMBER_OF_REELS = 5;

  const WILD_SYMBOL_ID = 8;
  const POT_SYMBOL_ID = 6;

  const BONUS_BUY = "BONUS_BUY";
  const LUCKYBET_BUY = "LUCKYBET_BUY";

  const NUMBER_OF_SCATTERS_TO_FREE_SPINS = {
    3: 7,
    4: 10,
    5: 13,
  };

  const MINI_JACKPOT = "MINI";
  const MINOR_JACKPOT = "MINOR";
  const MAJOR_JACKPOT = "MAJOR";
  const MAXI_JACKPOT = "MAXI";
  const GRAND_JACKPOT = "GRAND";

  const getPotKey = (pot) => {
    return `${pot.toLowerCase()}Jackpot`;
  };

  const getPotTitlePath = (jackpot) => {
    switch (jackpot) {
      case MINI_JACKPOT:
      case MINOR_JACKPOT:
      case MAJOR_JACKPOT:
      case MAXI_JACKPOT:
      case GRAND_JACKPOT:
        return `graphics/Generic/Symbols/Pot/Pot_Titles/Symbol_Pot_${jackpot}.png`;
      default:
        return null;
    }
  };

  const getRandom = (max) => {
    return Math.floor(Math.random() * max) + 1;
  };

  const getMaxWinValue = () => {
    const stakeController = resourceManager.getController("stakeController");
    const baseStake =
      stakeController.CurrentBetPerLine * stakeController.CurrentWinLineCount;
    const maxWin = baseStake * 10000;
    return maxWin;
  };

  async function playMovie(movie) {
    movie.visible = true;
    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });
    movie.gotoAndPlay(0);
    movie.onComplete = () => {
      resolver();
    };
    await promise;
    movie.visible = false;
  }

  return {
    NUMBER_OF_REELS,
    WILD_SYMBOL_ID,
    POT_SYMBOL_ID,
    BONUS_BUY,
    LUCKYBET_BUY,
    NUMBER_OF_SCATTERS_TO_FREE_SPINS,
    MINI_JACKPOT,
    MINOR_JACKPOT,
    MAJOR_JACKPOT,
    MAXI_JACKPOT,
    GRAND_JACKPOT,
    getPotKey,
    getPotTitlePath,
    getRandom,
    getMaxWinValue,
    playMovie,
  };
})();
